import React, { useState } from 'react';
import { useBrand } from '@/context/BrandContext';
import { EditableText } from '../ui/EditableText';
import { BrandSectionLayout } from './BrandSectionLayout';

interface GuidelinesSectionProps {
  section: any;
  isEditing: boolean;
  isGlobalDarkMode: boolean;
  editingElement: string | null;
  setEditingElement: (element: string | null) => void;
  updateSectionContent: (key: string, value: string) => void;
  updateSectionStyles: (key: string, styles: any) => void;
  pageNumber?: number;
}

export const GuidelinesSection: React.FC<GuidelinesSectionProps> = ({
  section,
  isEditing,
  isGlobalDarkMode,
  editingElement,
  setEditingElement,
  updateSectionContent,
  updateSectionStyles,
  pageNumber = 1
}) => {
  const { state } = useBrand();

  return (
    <BrandSectionLayout
      section={section}
      isEditing={isEditing}
      isGlobalDarkMode={isGlobalDarkMode}
      editingElement={editingElement}
      setEditingElement={setEditingElement}
      updateSectionContent={updateSectionContent}
      updateSectionStyles={updateSectionStyles}
      pageNumber={pageNumber}
      showPageNumber={true}
      isCoverPage={true}
    >
      {/* Main flex container with full height */}
      <div className="h-full flex items-center justify-center">
        <EditableText
          value={section.content.brandBookTitle || '{{brandName}}'}
          onChange={(value) => updateSectionContent('brandBookTitle', value)}
          element="h1"
          className="text-8xl font-bold leading-tight tracking-tight"
          placeholder="Enter title..."
          multiline={true}
          editModeEnabled={isEditing}
          isEditing={isEditing && editingElement === 'brandBookTitle'}
          onEditStart={() => setEditingElement('brandBookTitle')}
          onEditEnd={() => setEditingElement(null)}
          onStyleChange={(styles) => updateSectionStyles('brandBookTitle', styles)}
          initialStyles={{
            fontFamily: state.brandData?.globalTitleFont || 'Inter',
            color: '#FFFFFF',
            fontWeight: 'bold',
            ...section.content.brandBookTitleStyles
          }}
          isGlobalDarkMode={isGlobalDarkMode}
          sectionBackgroundColor={section.customization?.backgroundColor || section.styles.backgroundColor}
        />
      </div>
    </BrandSectionLayout>
  );
};